export default {
  getType(state) {
    return state.type
  },
  getFilters(state) {
    return state.filters
  },
  getXAxis(state) {
    return state.x_axis
  },
  getActiveContextFilters(state) {
    return state.activeContextFilters
  },
}
